export default "ligo compile storage starmap3.jsligo ''\n\nligo run dry-run starmap3.jsligo '' ''\n";